import React from 'react';
import "./helpers.scss";

const Loading = () => {
    return (
        <img className='loading_image' src="./images/loading.gif" />
    );
};

export default Loading;